<script lang="ts">
    
    import './styles.scss';
    import { Router, Route, navigate } from 'svelte-navigator';
    import Home from './Pages/Home.svelte';
    import AvatarSelect from './Pages/AvatarSelect.svelte';
    import Trivial from './Pages/Trivial.svelte';
    import { setContext } from 'svelte';
    import Music from './Components/Music.svelte';
    import { preloadResources } from './environment';
    import Loading from './Components/Loading.svelte';
    import Redirect from './Components/Redirect.svelte';

    const basepath: string = new URL(document.baseURI).pathname;

    let mainTheme: Music;
    let preloadCount = 0;
    let allReady = preloadResources.length === 0;

    setContext('playMainTheme', playMainTheme);
    setContext('stopMainTheme', stopMainTheme);

    setTimeout(() => allReady = true, 2000);

    onWindowResize();
    
    function onWindowResize(): void {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }

    function playMainTheme(): void {
        mainTheme?.play();
    }

    function stopMainTheme(): void {
        mainTheme?.stop();
    }

    function onPreload(): void {
        allReady = ++preloadCount === preloadResources.length;
    }

    function crossorigin(asValue: string): 'anonimous' | undefined {
        if ('image' === asValue) {
            return;
        }
        return 'anonimous';
    }

</script>

<svelte:head>
    <!-- Precargamos todas los recursos necesarios-->
    {#each preloadResources as preload}
    <link
        rel="preload"
        on:load={onPreload}
        href={preload.src}
        as={preload.linkAs}
        crossorigin={crossorigin(preload.linkAs)}>
    {/each}
</svelte:head>

<svelte:window on:resize={onWindowResize} />

<Music bind:this={mainTheme} volume={0.35} src="sound/main_theme.mp3" />

<Router primary={false} {basepath}>

    {#if !allReady}
        <div class="view-wrapper">
            <div class="view">
                <Loading />
            </div>
        </div>
    {:else}
        <Route path="inicio">
            <div class="view-wrapper">
                <Home />
            </div>
        </Route>
        <Route path="avatar">
            <div class="view-wrapper">
                <AvatarSelect />
            </div>
        </Route>
        <Route path="trivial">
            <div class="view-wrapper">
                <Trivial />
            </div>
        </Route>
        <Route path="*">
            <Redirect to="inicio" />
        </Route>
    {/if}

</Router>
